export const SetPrimaryContact =
  'Your account does not currently have a Primary contact, please could you update the necessary fields below: ';
export const UpdatePrimaryContact =
  'We are in the process of making sure customer contacts are correct. Please check the information below and change where necassry:';
